module.exports = {
  reversal: '.reversal',
  refund: '.refund',
  manual: '.manual',
  rollback: '.rollback'
};
